<template lang="html">
  <div class="add-email">
    <form v-if="!sent"
      @submit.prevent="submit"
      class="form-group text-center">
      <label v-if="action === 'FIRST'" for="email">Para poder publicar en nuestro sitio, necesitás agregar y verificar un correo electrónico en tu perfil de usuario</label>
      <label for="email">Enviaremos un correo de verificación</label>
      <input
        v-model="email"
        id="email"
        @keypress.enter.prevent="submit"
        @input="handleInput"
        class="form-control mt-3"
        type="email">
      <div v-if="showError" class="error">
        <ul style="list-style-type:none; padding-inline-start: 0;">
          <li v-for="(error, index) in errorMessages" :key="`error-${index}`">
            <ul style="list-style-type:none; padding-inline-start: 0;">
              <li v-for="(message, index) in error" :key="`message-${index}`">
                {{message}}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="mt-3 w-100 text-center" style="position: relative;">
        <SquaredButton
          @click="$emit('close')"
          type="button"
          styleType="default"
          noUpperCase
          label="Cancelar" />
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="isFetching"
          type="submit"
          styleType="primary"
          noUpperCase
          label="Enviar" />
      </div>
    </form>
    <div v-else class="form-group text-center">
      <label v-if="!swappingMainEmail" for="">Te enviamos un email a tu cuenta, por favor leelo y clickeá en el enlace de verificación</label>
      <label v-else for="">El email que ingresaste ya se encontraba verificado en tu cuenta. Te lo asignamos como email principal. </label>
      <div class="mt-4 w-100 text-center">
        <button v-if="!!then"
                @click="goToProfile"
                class="btn btn-default">
          Ir al perfil
        </button>
        <SquaredButton
          @click="handleClose"
          type="button"
          styleType="primary"
          noUpperCase
          label="Cerrar" />
      </div>
      <p class="mt-4" v-if="!swappingMainEmail">
        El email puede tardar 3 minutos en llegarte.
        <br>
        <button :disabled="count > 0"
          @click="resendCode"
          class="btn btn-link pr-0 align-baseline">
          envialo nuevamente
        </button>
        <span v-if="count > 0"> en {{ count }} s</span>
      </p>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import userUtilsMixin from '@/mixins/userUtils'

export default {
  mixins: [
    userUtilsMixin
  ],

  props: {
    then: Function,
    props: Object
  },

  data: () => ({
    email: '',
    sent: false,
    showError: false,
    errorMessages: {},
    isFetching: false
  }),

  computed: {
    count () { return this.userUtilsCount },

    /** props.action determines what type of email is being added
     *  FIRST: adding a main email address for the first time (for users registered via FB
     *  MAIN: changing main email address for another one
     *  OTHER: adding an alternative email address */
    action () {
      return this.props && this.props.action
    },

    currentEmail () {
      return this.props && this.props.email
    },

    otherVerifiedEmails () {
      return store.state.user.emails.filter(e => e.email !== store.state.user.email && e.verified)
    },

    emailAlreadyVerified () {
      return this.otherVerifiedEmails.filter(e => e.email === this.email).length > 0
    },

    swappingMainEmail () {
      return this.action === 'MAIN' && this.emailAlreadyVerified
    },

    person: () => store.state.user.person
  },

  mounted () {
    this.email = this.currentEmail
  },

  methods: {
    submit () {
      if (!this.email) {
        this.showError = true
        this.errorMessages.email = ['Por favor, ingresá un correo']
        return
      }

      this.isFetching = true
      const dispatchAction = this.action === 'OTHER' ? 'user/storeEmail' : 'user/updateEmail'
      return store.dispatch(dispatchAction, { person: this.person, email: this.email })
        .then(() => {
          this.sent = true
          if (!this.swappingMainEmail) {
            // activate countdown
            this.userUtilsCount = 60
            this.userUtilsCountdown()
          }
          if (this.action === 'MAIN') {
            this.pushToDataLayer('My profile page', 'Main email change')
          }
          return true
        })
        .catch((er) => {
          const messages = er.response && er.response.data && er.response.data.error &&
            er.response.data.error.message && er.response.data.error.message.errors
          if (messages) {
            this.errorMessages = messages
          }
          this.showError = true
        })
        .finally(() => { this.isFetching = false })
    },

    handleInput (e) {
      if (this.showError) {
        this.showError = false
        this.errorMessages = {}
      }
    },

    resendCode () {
      return this.submit()
    },

    handleClose () {
      this.$emit('close')
      store.dispatch('user/fetchUserInfo')
    },

    goToProfile () {
      this.then()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .add-email {
    & input {
      &:invalid {
        border-color: var(--danger);
      }
    }

    & .error {
      color: var(--danger);
      text-align: center;
      padding-top: 0.5rem;
      padding-bottom: 0;
      margin-right: auto;
      margin-left: auto;
      max-width: 320px;

      &.show {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/AddEmail.vue